import { GlobalLoading } from '@/shared/components';
import { Address } from '@/types/user';
import { DOMAIN, LINKS } from './constant';

export const getAddressState = (address: Partial<Address>) => {
  if (address?.addressStatus === 'ACTIVE') {
    return 'active';
  }
  return 'pending';
};

export const paymentOptions = (t) => {
  return [
    { label: t('payment.method.e-tax'), value: 'e-tax' },
    {
      label: t('payment.method.credit.card'),
      value: 'credit',
    },
  ];
};

export const getPaymentMethodLabel = (paymentValue: string, t) => {
  return paymentOptions(t).find((payment) => payment.value === paymentValue)?.label || '';
};

export const processNumberString = (input: string): number => {
  const parsedValue = Number(input);

  if (isNaN(parsedValue)) {
    return 0;
  }

  return parsedValue;
};

export const redirectLoginPage = () => {
  GlobalLoading.show();
  window.location.replace(`${LINKS.login}?returnUrl=${DOMAIN}${window.location.pathname}`);
};

export const redirectOrgPage = (redirectReferer: boolean = false) => {
  GlobalLoading.show();
  let redirectConfig = '';
  if (redirectReferer) {
    redirectConfig = '#/lt?cmd=FullRegistrationData&regType=Full&loyaltyLitetoFullReg=false';
  }
  window.location.replace(`${LINKS.organization}${redirectConfig}`);
};

export const scrollToTop = () => {
  window.scrollTo({
    top: 0,
    behavior: 'smooth',
  });
};

export const scrollTo = (top: number, behavior: 'smooth' | 'instant' | 'auto' = 'smooth') => {
  window.scrollTo({
    top,
    behavior,
  });
};

export const trimAll = (obj) => {
  if (typeof obj === 'string') {
    return obj?.trim();
  } else if (Array.isArray(obj)) {
    return obj.map((item) => trimAll(item));
  } else if (typeof obj === 'object' && obj !== null && !(obj instanceof File)) {
    const trimmedObj = {};
    for (const key in obj) {
      if (obj.hasOwnProperty(key)) {
        trimmedObj[key] = trimAll(obj[key]);
      }
    }
    return trimmedObj;
  }

  return obj;
};

export const uniqueTitle = (title: string) => {
  if (!title) return '';
  if (title.startsWith('[') && title.endsWith(']')) {
    let duplicated = false;
    const contents = title.slice(1, -1).split(',');
    const uniqueContents = [];
    contents.forEach((item) => {
      const content = item.trim();
      if (!uniqueContents.includes(content)) {
        uniqueContents.push(content);
      } else {
        duplicated = true;
      }
    });
    if (!duplicated) {
      return title;
    }
    return uniqueContents.join(', ');
  } else {
    return title;
  }
};
